<div class="lock-details user-type">
  <div class="header my-4">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto text-center">
        {{ "FILTER_ACTIVITIES" | translate }}
      </h1>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>

    <div class="row my-4 mx-3 pt-1 justify-content-between align-items-start">
      <div class="col-2"></div>
      <div class="col-6">
        <p class="text-center heading1 mb-0">
          {{ "FILTER_BY_USER_TYPE" | translate }}
        </p>
      </div>
      <div
        class="col-3 reset-btn"
        role="button"
        (click)="resetFilter()"
        [ngClass]="{
          'reset-btn-active': hasSelection
        }"
      >
        <p class="text-right">
          {{ "RESET" | translate }}
        </p>
      </div>
    </div>
  </div>

  <div class="activity-type-container">
    <div>
      <ng-container *ngFor="let userType of userTypes; let i = index">
        <div class="form-group rounded-top form-container">
          <div
            class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
          >
            <div class="d-flex list-box full align-items-center">
              <span class="row-icon col-2 text-center">
                <img src="assets/svg/ico-user-group-gray.svg" class="icon" />
              </span>

              <span class="title bold col-8 overflow-ellipsis">
                {{ userType.label | translate }}
              </span>

              <span class="selected-value-container checked-spacer col-2">
                <span class="selected-value time-right"> </span>
                <span class="btn-not-text">
                  <button
                    class="icon-button-checked"
                    type="button"
                    (click)="toggleUserType(userType.value)"
                  >
                    <img
                      class="icon"
                      [src]="
                        isSelected(userType.value)
                          ? '/assets/svg/ico-checkmark-circle-outline.svg'
                          : '/assets/svg/ico-circle.svg'
                      "
                    />
                  </button>
                </span>
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <button class="btn btn-danger px-3 w-100 btn-submit" (click)="submit()">
        {{ "SEE_RESULTS" | translate }}
      </button>
    </div>
  </div>
</div>
